import React from "react";

const Rewards = () => {
  return (
    <div className="space-y-4">
      <h1 className="text-lg font-semibold text-foreground">Rewards</h1>
      <p className="text-sm text-muted-foreground">
        Your rewards, bonuses, and offers will be shown here. Connect this view
        to your rewards data when ready.
      </p>
    </div>
  );
};

export default Rewards;

